import { projectPath, type Topic, type WorkshopProject } from '@/data/profile';
import { AppLink } from '@/lib/router';

type ProjectsRailProps = {
  topic: Topic;
  projects: WorkshopProject[];
};

export function ProjectsRail({ topic, projects }: ProjectsRailProps) {
  return (
    <nav className="projects-rail" aria-label="Projects">
      <div className="projects-rail__body">
        <p className="projects-rail__title">Projects</p>
        <ol className="projects-rail__list">
          {projects.map((project) => (
            <li key={project.slug}>
              <AppLink href={projectPath(topic.slug, project.slug)} className="projects-rail__link">
                {project.label}
              </AppLink>
            </li>
          ))}
        </ol>
      </div>
      <div className="projects-rail__saber" aria-hidden="true">
        <div className="saber__blade">
          <span className="saber__core" />
          <span className="saber__bloom" />
        </div>
        <div className="saber__emitter" />
        <div className="saber__hilt">
          <span className="saber__switch" />
        </div>
      </div>
    </nav>
  );
}
